import React from "react";
import Banner from "../components/banner/Banner";
import Section1 from "../components/Section1/Section1";
import Section2 from "../components/Section2/Section2";

const Home = ({ darkSide, toggleDarkMode }) => {
  return (
    <>
      <Banner darkSide={darkSide} toggleDarkMode={toggleDarkMode} />
      <Section1 darkSide={darkSide} toggleDarkMode={toggleDarkMode} />
      <Section2 darkSide={darkSide} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default Home;
